import { render, staticRenderFns } from "./workModal.vue?vue&type=template&id=e9910c4a&scoped=true"
import script from "./workModal.vue?vue&type=script&lang=js"
export * from "./workModal.vue?vue&type=script&lang=js"
import style0 from "./workModal.vue?vue&type=style&index=0&id=e9910c4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9910c4a",
  null
  
)

export default component.exports